import { useMemo } from "react";

import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { VictoryAxis, VictoryChart, VictoryLine, VictoryTheme } from "victory";
import ChartLabel from "../../../../../components/ChartLabel";

const colors = ["#008000", "#00b050", "#bee397"];

const MarginChart = ({ data }) => {
	const { t } = useTranslation();
	const values = useMemo(() => Object.values(data), [data]);

	const lines = useMemo(() => {
		return values.map((element, index) => (
			<VictoryLine
				key={index}
				data={element}
				labels={({ datum }) =>
					Intl.NumberFormat("en-US", {
						notation: "compact",
						maximumFractionDigits: 2,
					}).format(datum._y)
				}
				x="month"
				y="margin"
				style={{ data: { stroke: colors[index] } }}
			/>
		));
	}, [values]);

	return (
		<Box>
			<ChartLabel text={t("total_margin") + " (€)"} color="#ADDB7B" />
			<VictoryChart
				theme={VictoryTheme.material}
				scale={{ x: "linear" }}
				width={1000}
				height={300}
			>
				<VictoryAxis
					style={{
						axisLabel: { padding: 30 },
					}}
					tickValues={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
				/>
				<VictoryAxis
					dependentAxis
					tickFormat={(t) =>
						Intl.NumberFormat("en-US", {
							notation: "compact",
							maximumFractionDigits: 1,
						}).format(t)
					}
				/>
				{lines}
			</VictoryChart>
		</Box>
	);
};

export default MarginChart;
